import { render, staticRenderFns } from "./SaleBrowse.vue?vue&type=template&id=798d68ce"
import script from "./SaleBrowse.vue?vue&type=script&lang=ts"
export * from "./SaleBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798d68ce')) {
      api.createRecord('798d68ce', component.options)
    } else {
      api.reload('798d68ce', component.options)
    }
    module.hot.accept("./SaleBrowse.vue?vue&type=template&id=798d68ce", function () {
      api.rerender('798d68ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/SaleBrowse.vue"
export default component.exports